import React, { FC } from 'react';

const IconApple: FC = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 200 245.6251526"
      {...props}
    >
      <path
        fill="#666"
        d="M167.0338898,130.4929352C167.3790588,167.6642303,199.6425476,180.0337677,200,180.1912079
                	c-0.2728119,0.8719177-5.1551666,17.6273346-16.9979553,34.934494
                	c-10.2379761,14.9633484-20.8628082,29.8709717-37.6006775,30.1797333
                	c-16.44664,0.3030548-21.7351532-9.7524719-40.5383377-9.7524719c-18.7974777,0-24.6732559,9.4441376-40.2418518,10.055954
                	c-16.1563072,0.6118469-28.4596024-16.1799774-38.7817993-31.088501
                	C4.7463217,184.0253296-11.3731403,128.3486481,10.2712269,90.7659531
                	c10.752449-18.6637115,29.9679127-30.4823723,50.8245697-30.7854347
                	c15.865078-0.3026276,30.8393822,10.6734962,40.5383415,10.6734962c9.6928177,0,27.8898773-13.1997681,47.0202484-11.2612038
                	c8.0086365,0.3333244,30.4893799,3.2350349,44.9242401,24.3644905c-1.163147,0.7210464-26.8236694,15.6593857-26.5447388,46.7356033
                	 M136.1243286,39.2177505C144.701828,28.8350334,150.4749603,14.3813334,148.8999939,0
                	c-12.3638153,0.4969213-27.3144379,8.2388935-36.1827087,18.6159096
                	c-7.94767,9.1893158-14.9080734,23.8973961-13.0300369,37.9940834c13.7809067,1.0662117,27.859169-7.0029488,36.4370956-17.3922424"
      />
    </svg>
  );
};

export default IconApple;
